// 参见 [【登录认证】前端接入文档](https://km.sankuai.com/page/21599502)

import * as utilParam from '@utiljs/param';
import { getEnv } from '@/utils';

export namespace EPassport {
    export interface CommonQuery {
        /**
         * 接入业务线，参见 [接入业务线](https://km.sankuai.com/page/21597964#id-BGSource-%E6%8E%A5%E5%85%A5%E4%B8%9A%E5%8A%A1%E7%BA%BF)。
         * 外卖填 `3` 即可
         */
        bg_source: number;

        /**
         * 申请接入 Epassport 的 Appkey
         */
        service: string;

        /**
         * 登录后的回跳地址（务必用 `encodeURIComponent` 编码）
         */
        continue: string;

        /**
         * 自定义配置名称，若未填则默认取service
         */
        feconfig?: string;
    }

    /**
     * [修改密码](https://km.sankuai.com/page/21599530)
     */
    export namespace EditPassword {
        export const BASE_PATH = '/portal/reset-password';

        export interface Query extends CommonQuery {
            /** 此参数适用于业务方需鉴定用户此次操作是否成功的情况 */
            is_signature?: 1;
        }
    }

    /**
     * [换绑手机](ttps://km.sankuai.com/page/21599527)
     */
    export namespace BindPhone {
        export const BASE_PATH = '/portal/bindphone';

        export interface Query extends CommonQuery {
            /**
             * [Epassport常用代码表#PartType-账号类型](https://km.sankuai.com/page/21597964#Epassport%E5%B8%B8%E7%94%A8%E4%BB%A3%E7%A0%81%E8%A1%A8-PartType-%E8%B4%A6%E5%8F%B7%E7%B1%BB%E5%9E%8B)
             */
            part_type?: number;

            /**
             * 登录token
             */
            bizlogintoken?: string;

            /**
             * 客户平台业务线标识
             */
            biz_line?: string;
        }
    }
}

/**
 * 根据不同环境获取相应的域名，参见
 * https://km.sankuai.com/page/21550853#id-%E5%95%86%E5%AE%B6%E7%AB%AF%E7%8E%AF%E5%A2%83
 */
export function getEPassportHost(env: string) {
    switch (env) {
        case 'stage':
            // ep 没有st
            // return 'https://fepassport.sjst.st.sankuai.com';
            return '//epassport.meituan.com';
        case 'test':
            return 'http://fepassport.sjst.test.sankuai.com';
        default:
            return '//epassport.meituan.com';
    }
}

const env = getEnv();
const target = getEPassportHost(env);
const protocol = env === 'prod' || env === 'stage' ? 'https' : 'http';
const origin = `${protocol}://${window.location.host}`; // 不知道为什么不直接用 `window.origin`，大概是历史原因吧...

const commonParams: EPassport.CommonQuery = {
    bg_source: 3,
    service: 'waimai-provider',
    feconfig: 'waimai.e.provider.uiconfig',
    continue: `${origin}/#/epassportcontinue`,
};

const EPassportOperation = {
    'edit-password': EPassport.EditPassword.BASE_PATH,
    'bind-phone': EPassport.BindPhone.BASE_PATH,
};

// prettier-ignore
type EPassportParamType<T extends keyof typeof EPassportOperation> = (
    T extends 'edit-password' ? EPassport.EditPassword.Query : (
        T extends 'bind-phone' ? EPassport.BindPhone.Query : never
    )
);

export default function getEPassportUrl<T extends keyof typeof EPassportOperation>(
    operation: T,
    params?: Partial<EPassportParamType<T>>,
) {
    const queryString = utilParam.stringify(params ? { ...commonParams, ...params } : commonParams);

    return `${target}${EPassportOperation[operation]}?${queryString}`;
}
